// extracted by mini-css-extract-plugin
module.exports = {"FileIndicator":"FileChooser_FileIndicator__3xQNz","FileName":"FileChooser_FileName__22QyB"};